import React from 'react';
import PropTypes from 'prop-types';

import { getPreorderData } from '../../Utils/VariantUtils';
import { StyledBadge } from './CollectionBadgeStyles';

var CollectionBadge = function CollectionBadge(_ref) {
  var tags = _ref.tags,
      newFromDate = _ref.newFromDate,
      newToDate = _ref.newToDate,
      preorderDate = _ref.preorderDate,
      productPreorderDate = _ref.productPreorderDate,
      selectedVariantInventory = _ref.selectedVariantInventory,
      lowStockThreshold = _ref.lowStockThreshold;

  var getNewBadge = function getNewBadge(newFromDate, newToDate) {
    var currentDate = new Date();
    if (newToDate && newFromDate && currentDate > new Date(newFromDate.value.replace(/-/g, '/')) && currentDate < new Date(newToDate.value.replace(/-/g, '/'))) {
      return true;
    }
  };

  var getBadgeText = function getBadgeText(newBadge, bestSellerBadge, lowStockBadge) {
    if (newBadge) return 'New';else if (bestSellerBadge) return 'Best Seller';else if (lowStockBadge) return 'Low Stock';
  };

  // Low in stock threshold
  var lowInStockThreshold = parseInt(lowStockThreshold) || 8;

  var preOrderBadge = getPreorderData(preorderDate);
  var productPreOrderBadge = getPreorderData(productPreorderDate);
  var bestSellerBadge = tags.includes('badge:bestseller');
  var newBadge = getNewBadge(newFromDate, newToDate);
  var lowStockBadge = selectedVariantInventory <= lowInStockThreshold && selectedVariantInventory > 0;

  var active = newBadge || bestSellerBadge || lowStockBadge;

  var badgeText = getBadgeText(newBadge, bestSellerBadge, lowStockBadge);

  return React.createElement(
    StyledBadge,
    { active: active, badgeText: badgeText },
    badgeText
  );
};

CollectionBadge.propTypes = {
  tags: PropTypes.array.isRequired,
  newFromDate: PropTypes.object,
  newToDate: PropTypes.object,
  selectedVariantInventory: PropTypes.number,
  preorderDate: PropTypes.object,
  productPreorderDate: PropTypes.object,
  lowStockThreshold: PropTypes.string
};

export default CollectionBadge;